import React, { PureComponent } from 'react';
import { Container, Header } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ManualsTable, PageHeader, Wrappers } from '../components';
import { ManualsForm } from '../forms';
import { Formatters } from '../utils';
import { withPageViewTracking, withAnalytics } from '../analytics';
import { compose } from 'react-apollo';
import { ApiStatuses } from '../api';
import { withManuals } from '../hoc';
import { withAuth } from '../auth';
import { TOOLS } from '../constants';

class Manuals extends PureComponent {
  state = {
    queryOptions: null,
    querySelections: null,
    manuals: null,
    windowWidth: window.innerWidth
  };

  static propTypes = {
    analytics: PropTypes.object.isRequired,
    brand: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    manualtype: PropTypes.array,
    language: PropTypes.array,
    productfamily: PropTypes.array,
    onChangeBrand: PropTypes.func,
    onHandleSearch: PropTypes.func,
    isMobile: PropTypes.bool,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string
      })
    })
  };

  async componentDidMount() {
    const { analytics } = this.props;
    analytics.incrementUserProperty(`Num of Product Manual Visits`);
  }

  trackResultsAnalytics = () => {
    const { querySelections } = this.state;
    const { analytics } = this.props;
    let queryOptionsAsArray = [];

    Object.keys(querySelections).forEach(key => {
      const selection = `${key} | ${querySelections[key]}`;
      queryOptionsAsArray.push(selection);
    });

    const formattedQueryOptions = queryOptionsAsArray.join(', ');

    analytics.trackEvent('Product Manual Searches', {
      Tool: 'Product Manuals',
      'Product Manual Parameters': formattedQueryOptions
    });
    analytics.incrementUserProperty(`Num of Product Manual Queries`);
  };

  onSubmit = async values => {
    const { onHandleSearch, brand, analytics } = this.props;
    // for Analytics values, get associated string from the values (likely numbers)
    let queryOptions = {};
    let querySelections = {};
    Object.keys(values).forEach(key => {
      const value = values[key];
      queryOptions[key] =
        !isNaN(Number(value)) && value !== '' ? Number(value) : value;
      querySelections[key] = Formatters.getNameFromValue(
        key,
        value,
        this.props[key.toLowerCase()]
      );
    });

    const selectedBrand =
      brand && brand.find(b => b.BrandId === queryOptions.Brand);

    analytics.trackFormSubmission({
      Tool: TOOLS.PRODUCT_MANUALS,
      Brand: selectedBrand && selectedBrand.Name
    });

    this.setState({ isLoading: true });
    const manuals = await onHandleSearch(queryOptions);
    if (manuals) {
      this.setState({
        formActive: false,
        queryOptions,
        querySelections,
        manuals
      });
      this.trackResultsAnalytics();
    }
    this.setState({ isLoading: false });
  };

  render() {
    const {
      brand,
      manualtype,
      language,
      productfamily,
      onChangeBrand,
      isMobile,
      match
    } = this.props;
    let brands =
      brand && brand.error
        ? {
            brand: null,
            brandStatus: ApiStatuses.Error,
            brandError: brand.error
          }
        : {
            brand,
            brandStatus: brand ? ApiStatuses.Loaded : ApiStatuses.Loading,
            brandError: null
          };

    const { manuals, isLoading, querySelections } = this.state;

    const singleBrandAuthorized =
      brands.brand && brands.brand.length === 1 ? brands.brand[0].Name : null;

    return (
      <Wrappers.Layout menu>
        <Container as="main">
          <PageHeader overlap data-qa="manuals">
            <Header as="h1" data-qa="manuals-header">
              <small>Manuals</small>
              <FormattedMessage
                id="title.manuals"
                description="Manuals page title"
                defaultMessage="Product Manuals"
              />
            </Header>
          </PageHeader>

          {brand && (
            <ManualsForm
              {...brands}
              manualType={manualtype}
              language={language}
              productFamily={productfamily}
              onHandleSubmit={this.onSubmit}
              onHandleOnChangeBrand={onChangeBrand}
              preSelect={match.params.id || singleBrandAuthorized || null}
            />
          )}

          <ManualsTable
            manuals={manuals}
            isLoading={isLoading}
            querySelections={querySelections}
            isMobile={isMobile}
          />
        </Container>
      </Wrappers.Layout>
    );
  }
}

export default compose(
  withAuth,
  withManuals,
  withAnalytics,
  withPageViewTracking({ eventName: 'Product Manual Page Visit' })
)(Manuals);



// WEBPACK FOOTER //
// ./src/pages/Manuals.js